/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Pepper = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Pepper"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#F33"
        d="M13.094 10.514c.952-3.186 1.953-5.37 4.955-4.647 2.017.486 3.18 3.153-.154 9.219-5.01 9.112-16.73 7.193-15.376 2.383 5.107.322 8.47.086 10.575-6.955"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M13.094 10.514c.952-3.186 1.953-5.37 4.955-4.647 2.017.486 3.18 3.153-.154 9.219-5.01 9.112-16.73 7.193-15.376 2.383 5.107.322 8.47.086 10.575-6.955"
      />
      <path
        fill="#F33"
        d="M5.113 7.09q.293 0 .324.3.102.795.205 1.243.11.45.34.677.23.229.688.34.458.11 1.272.22.126.015.205.102a.3.3 0 0 1 .087.22q0 .269-.285.323-.822.15-1.28.276-.457.119-.687.339t-.34.661q-.103.434-.205 1.205a.35.35 0 0 1-.103.213.32.32 0 0 1-.221.078q-.285 0-.316-.307a11 11 0 0 0-.206-1.213q-.102-.448-.331-.67-.23-.227-.688-.337-.45-.119-1.248-.245Q2 10.468 2 10.194q0-.276.284-.323.814-.15 1.273-.268.465-.126.695-.339.236-.22.34-.654.11-.433.205-1.213.031-.306.316-.306"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M5.113 7.09q.293 0 .324.3.102.795.205 1.243.11.45.34.677.23.229.688.34.458.11 1.272.22.126.015.205.102a.3.3 0 0 1 .087.22q0 .269-.285.323-.822.15-1.28.276-.457.119-.687.339t-.34.661q-.103.434-.205 1.205a.35.35 0 0 1-.103.213.32.32 0 0 1-.221.078q-.285 0-.316-.307a11 11 0 0 0-.206-1.213q-.102-.448-.331-.67-.23-.227-.688-.337-.45-.119-1.248-.245Q2 10.468 2 10.194q0-.276.284-.323.814-.15 1.273-.268.465-.126.695-.339.236-.22.34-.654.11-.433.205-1.213.031-.306.316-.306"
      />
      <path
        fill="#F33"
        d="M9.667 2.5q.217 0 .256.236.1.6.178.945.09.345.257.523.177.176.524.275.356.089.997.206.237.04.237.257 0 .216-.237.255-.631.119-.987.227-.356.098-.524.275-.167.178-.257.523-.089.335-.188.925-.039.237-.256.236-.227 0-.257-.236-.11-.6-.187-.935-.08-.345-.258-.522-.168-.177-.523-.276a8 8 0 0 0-.978-.217q-.247-.039-.247-.255 0-.217.237-.257.633-.127.988-.226t.523-.276q.178-.177.258-.512.078-.335.187-.925.03-.246.257-.246"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M9.667 2.5q.217 0 .256.236.1.6.178.945.09.345.257.523.177.176.524.275.356.089.997.206.237.04.237.257 0 .216-.237.255-.631.119-.987.227-.356.098-.524.275-.167.178-.257.523-.089.335-.188.925-.039.237-.256.236-.227 0-.257-.236-.11-.6-.187-.935-.08-.345-.258-.522-.168-.177-.523-.276a8 8 0 0 0-.978-.217q-.247-.039-.247-.255 0-.217.237-.257.633-.127.988-.226t.523-.276q.178-.177.258-.512.078-.335.187-.925.03-.246.257-.246"
      />
      <path
        fill="#94B200"
        d="M18.718 4.604c.845-.482 1.858-.366 2.953-.073a.443.443 0 1 1-.23.855c-1.07-.287-1.77-.306-2.281-.013-.224.128-.44.33-.64.645.853.39 1.464 1.26 1.476 2.733-2.14 0-4.29-.568-5.496-1.647.709-1.035 1.66-1.569 3.136-1.332.292-.53.646-.918 1.082-1.168"
      />
    </g>
  </svg>
);

export const PepperIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'pepper-icon'}
      icon={Pepper}
      {...props}
      size={size}
    />
  );
};
